import { takeLatest } from "redux-saga/effects";
import { deleteTenantRowSaga, getTenantDetailSaga, getTenantsListSaga, updateTenantRowSaga, updateUserRowSaga } from "./saga";
import { DELETE_TENANT_ROW_REQUEST, DELETE_USER_V3_ROW_REQUEST, GET_TENANTS_LIST_REQUEST, GET_TENANT_DETAIL_REQUEST, UPDATE_TENANT_ROW_REQUEST, UPDATE_USER_V2_ROW_REQUEST } from "../consts";

export function* watchTenantDetail() {
  yield takeLatest(GET_TENANT_DETAIL_REQUEST, getTenantDetailSaga);
}

export function* watchTenantList() {
  yield takeLatest(GET_TENANTS_LIST_REQUEST, getTenantsListSaga);
}

export function* watchTenantRow() {
  yield takeLatest(DELETE_TENANT_ROW_REQUEST, deleteTenantRowSaga);
  yield takeLatest(UPDATE_TENANT_ROW_REQUEST, updateTenantRowSaga);
}

export function* watchUserRow() {
  yield takeLatest(DELETE_USER_V3_ROW_REQUEST, deleteTenantRowSaga);
  yield takeLatest(UPDATE_USER_V2_ROW_REQUEST, updateUserRowSaga);
}
